function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 3a1 1 0 10-2 0v3.952H3a1 1 0 000 2h3.053L2.838 21.81h-.457a1.62 1.62 0 00-1.62 1.62 6.572 6.572 0 0013.144 0 1.62 1.62 0 00-1.62-1.62h-.457L8.614 8.953H15v1.477a1 1 0 102 0V8.952h6.386L20.172 21.81h-.458a1.62 1.62 0 00-1.619 1.62 6.572 6.572 0 0013.143 0 1.62 1.62 0 00-1.619-1.62h-.457L25.947 8.953H29a1 1 0 100-2H17V3zm11.36 20.81h.862a4.571 4.571 0 01-9.11 0h8.248zm-1.26-2l-2.433-9.735-2.434 9.735H27.1zm-16.073 2h.862a4.571 4.571 0 01-9.111 0H11.027zm-1.26-2l-2.434-9.735L4.9 21.81h4.867z",
  fill: "currentColor"
})));